import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const EmptyResultMessageContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 2rem 1rem;
  display: grid;
  grid-template-columns: 24px auto;
  grid-column-gap: 1rem;
  background-color: ${palette.softPurple};
  border: 1px solid ${palette.deepPurple};
  border-radius: 8px;
  max-width: 635px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;

  p {
    max-width: 460px;
  }

  @media screen and (max-width: ${layout.sm}) {
    grid-template-columns: 1fr;
    grid-row-gap: 1rem;

    svg {
      justify-self: center;
    }

    p {
      text-align: center;
      margin: 0 auto;
    }
  }
`;
